import useLenis from "@/hooks/useLenis";
import Layout from "@/components/Layout";
import LandingReelHero from "@/components/LandingReelHero";
import FilmStripSection from "@/components/FilmStripSection";
import WorldDoorsStack from "@/components/WorldDoorsStack";

/**
 * Games — Founder plain-ink 2026-02-15.
 * The old landing content (reel · film strip · thirteen doors) now lives
 * under the Games tab. The Inner Sanctum stays on the landing itself.
 *
 * Font posture: this page and every card / banner inside it are exempt
 * from the site-wide Times New Roman ruling. The `games-shell` class
 * flips typography back to the world-specific display families so the
 * game brand identities stay intact.
 */
export default function Games() {
  useLenis();
  return (
    <Layout>
      <div
        data-testid="games-shell"
        className="games-shell relative"
      >
        <LandingReelHero />
        <FilmStripSection />
        <WorldDoorsStack />
      </div>
    </Layout>
  );
}
